<h2>Confirmation</h2>
<div class="confirmation-message">
  <i class="icon icon--check-circle confirmation-message__icon"></i>
  <p *ngIf="!examInfo.isExamPurchase && !ccpInfo.isCcpPurchase && !isNoMoneyDue()">Thank you for your payment!</p>
  <p *ngIf="isNoMoneyDue()">Thank you for your request. Item has been ordered.</p>
  <p *ngIf="examInfo.isExamPurchase">Thank you for your payment! You must schedule and take your examination by
    {{examInfo.eligibilityEndDate | date : "M/d/yyyy"}}. You will receive a
    confirmation email shortly. <strong>Click the ‘Continue’ button</strong> to go to the site where you can schedule
    an examination appointment. Please note that you may be required to create a new account on this site to continue
    the scheduling process.</p>
  <p *ngIf="examInfo.isExamPurchase">
      The NBRC is determined to safeguard the integrity of its credentialing programs by ensuring the security of the examinations. In today’s world of instant information sharing, we believe it is important for all candidates to be reminded of the NBRC’s and PSI’s policies regarding examination security. We take these policies very seriously and expect that all credentialed practitioners and candidates will do the same. Please take a moment to watch the brief video below for more information about examination security.
      <br><a href="https://nbrc.org/SecurityVideo">Security Video</a>
  </p>    
  <a *ngIf="examInfo.isExamPurchase" href="{{examInfo.schedulingLink}}" target="_blank" class="button">Continue</a>
  <section *ngIf="ccpInfo.isCcpPurchase && ccpInfo.isAuditRequired">
    <p>Thank you for participating in the online Credential Maintenance Program!</p>
    <p>You have been selected to provide documentation of the CE information you entered as part of our random audit process. 
      To complete your recertification, you must submit the information below by {{ccpInfo.requiredByDate | date : "M/d/yyyy"}}:</p>
    <ul>
      <li *ngIf="ccpInfo.isAEC">
        	A copy of your current, active, unrestricted license or credential that qualified you for the credential.  
      </li>
      <li>A copy of the certificate for each CE course you entered. All certificates must include your name, date of completion and the number of hours awarded.</li>
      <li>A copy of this notice or the email sent to you.</li>
    </ul>
    <p>
      To expedite this process, submit copies of the CE completion certificates along with this notice by fax to 913.712.9283 or by 
      email in a single PDF file to <a href="Service@nbrc.org">Service@nbrc.org</a>. We are not able to accept screenshots and/or photos of CE completion certificates.       
      <span *ngIf="!ccpInfo.isAEC">To review the courses you submitted, log in to the Practitioner Portal at <a href="http://NBRC.org">nbrc.org</a> 
        and select 'Enter my CEUs.'</span>      
      If you are unable to submit your documentation by fax or email, mail your documents to: 
    </p>
    <p>NBRC<br>10801 Mastin Street, Suite 300<br>Overland Park, KS 66210</p>
    <p>If you have questions regarding this notice, please contact us at 913.895.4900 or <a href="Service@nbrc.org">Service@nbrc.org</a>.</p>
  </section>
  <section *ngIf="ccpInfo.isCcpPurchase && !ccpInfo.isAuditRequired">
    <p>You have successfully completed the Credential Maintenance Program (CMP)! Through this accomplishment, you have
      demonstrated the level of excellence required to maintain your credential(s) with the National Board for
      Respiratory Care. A certificate and wallet card with your new expiration date will be mailed to you within 30 days
      after your certification was due.</p>
    <p>The following information is provided as a reminder for your next five year cycle:</p>
    <ul>
      <li>To maintain your credential, you MUST renew your credential through the Credential Maintenance Program (CMP).
        The CMP is your pathway to recertifying ANY of your NBRC credentials.</li>
      <li>Detailed information on the CMP requirements and processes is available online at <a
          href="http://NBRC.org">nbrc.org</a>. Click on the &ldquo;Credentialed Practitioners&rdquo; section to login
        and obtain the information you need to get started.</li>
      <li>You will be sent a CMP Invoice each year. Individuals who pay their CMP fee each consecutive year will not be required to submit a fee when 
          recertifying at the end of their five-year credential term. If you do not pay the CMP fee each consecutive year, you will owe $25 for each 
          year not paid during your five-year credential term.</li>
	    <li>We are constantly looking for ways to champion and inform you, our credentialed practitioners. 
        We offer a single fee for all products and services, make the latest credentialing news available to all practitioners online at nbrc.org 
        and provide representation with organizations and state agencies that impact your profession.</li>
      <li>It is imperative that you keep your email and mailing addresses up to date with the NBRC. Please notify the
        NBRC of any changes in your name or address online at <a href="http://www.nbrc.org">www.nbrc.org</a> or by mail
        at 10801 Mastin Street, Suite 300, Overland Park, KS 66210.</li>
    </ul>
    <p>If you have questions regarding this notice, please contact us at <a href="tel:9138954900">913.895.4900</a> or <a
        href="Service@nbrc.org">Service@nbrc.org</a>.</p>
  </section>
</div>
<div *ngIf="purchase.products.length && !ccpInfo.isCcpPurchase && purchase.total >= 0">
  <div class="data-item">
    <div *ngIf="!examInfo.isExamPurchase" class="data-item__label label">
      <label for="practitionerName" class="label">Name</label>
    </div>
    <div *ngIf="examInfo.isExamPurchase" class="data-item__label label">
      <label for="practitionerName" class="label">Name</label>
    </div>
    <div class="data-item__value">
      {{purchase.practitionerName}}
    </div>
  </div>
  <div class="data-item">
    <div class="data-item__label label">
      <label for="paymentDate" class="label">Payment Date</label>
    </div>
    <div class="data-item__value">{{purchase.paymentDate | date : "M/d/yyyy"}}</div>
  </div>
  <div class="data-item">
    <div class="data-item__label label">
      <label for="paymentMethod" class="label">Payment Method</label>
    </div>
    <div class="data-item__value">{{paymentMethodLabel}}</div>
  </div>
</div>
<app-product-list *ngIf="purchase.products.length && !ccpInfo.isCcpPurchase && purchase.total >= 0" [showConfirmation]="true" [customPurchase]="purchase"></app-product-list>